import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { defs } from '../defs';

@Injectable()
export class PopulationQueryResolve implements Resolve<any> {
	constructor(private router: Router) {}

	resolve(route: ActivatedRouteSnapshot) {
		const queryParams = JSON.parse(localStorage.getItem(defs.populationFilter));
		if (!Object.keys(route.queryParams).length && queryParams && Object.keys(queryParams).length) {
			this.router.navigate(['population'], { queryParams });
		}
	}
}
